export function getIncrease(current, previous, percent = true) {
    if (previous === 0 && current !== 0) {
        return Infinity
    }
    else if ((current === 0 && previous === 0) || (current === previous)) {
        return 0;
    }

    return (current - previous) / previous * (percent ? 100 : 1);
}



// WEBPACK FOOTER //
// ./src/helpers/stats.js